import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { isOTPValid } from "../../redux/booking-validation";
import { useDispatch, useSelector } from "react-redux";
import { sendOTP } from "../../utils/requestHandler";

const TwoFactorAuthModal = ({ onClose, userDetails }) => {
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [error, setError] = useState("");
  const [timer, setTimer] = useState(90);
  const [reattempt, setReattempt] = useState(0);
  const dispatch = useDispatch();
  const loggedInStatus = useSelector(
    (state) => state.bookingValidation.loggedIn
  );
  const timerRef = useRef(null);

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (/^[0-9]$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value !== "" && index < 5) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if ((e.key === "Backspace" || e.key === "Delete") && otp[index] === "") {
      if (index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  const handleSubmit = () => {
    const enteredOtp = otp.join("");
    dispatch(
      isOTPValid({
        booking_id: userDetails.booking_id,
        guest_id: userDetails.guest_id,
        otp: enteredOtp,
      })
    );
    if (loggedInStatus === false) {
      setError(
        "Your entered OTP is incorrect, please enter the valid OTP which was sent to your email."
      );
    } else {
      setError("");
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const paste = e.clipboardData.getData("text").slice(0, 6);
    if (/^[0-9]+$/.test(paste)) {
      const newOtp = paste.split("");
      for (let i = newOtp.length; i < 6; i++) {
        newOtp.push("");
      }
      setOtp(newOtp);
      document.getElementById(`otp-input-${newOtp.length - 1}`).focus();
    }
  };

  const handleResend = () => {
    setReattempt((prev) => prev + 1);
    sendOTP(userDetails?.booking_id, userDetails?.guest_id);
    setOtp(Array(6).fill(""));
    setError("");
    setTimer(90);
    toast.success("OTP sent successfully");
    runTimer();
  };

  const runTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    runTimer();
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="bg-white rounded-lg p-8 w-full max-w-sm mx-4">
        <div className="flex w-full relative justify-center">
          <h2 className="text-2xl font-bold uppercase mb-4">
            {reattempt > 3 ? "Warning" : "VERIFY CODE"}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 absolute right-0 top-0 text-3xl hover:text-gray-700"
          >
            &times;
          </button>
        </div>
        {reattempt > 3 ? (
          <p className="text-center mb-6 text-[#E3750C]">
            Code which you entered is wrong, please contact Customer Service at
            (800) 814-7100 or email: service@margaritavilleatsea.com 
          </p>
        ) : (
          <p className="text-center mb-6">
            A one-time verification code was sent to the primary guest phone
            number {userDetails.mobile_no} and primary guest email{" "}
            {userDetails.email}
          </p>
        )}
        {reattempt <= 3 && timer > 0 && (
          <div className="mb-4 flex justify-center space-x-2">
            {otp.map((value, index) => (
              <input
                autoFocus={index === 0}
                key={index}
                id={`otp-input-${index}`}
                type="text"
                value={value}
                onChange={(e) => handleChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                onPaste={handlePaste}
                maxLength="1"
                className="w-10 p-2 border border-gray-300 rounded text-center focus:outline-none focus:ring-2 focus:ring-mv-darkblue"
              />
            ))}
          </div>
        )}
        {error ? (
          <p className="text-red-500 text-center mb-4">{error}</p>
        ) : (
          <div className="text-center mb-4">
            <p>
              {timer > 0 ? (
                `00:${timer.toString().padStart(2, "0")}`
              ) : (
                <p className="text-red-500">Your OTP has expired</p>
              )}
            </p>
          </div>
        )}
        <div className="text-center">
          <button
            onClick={reattempt > 3 || timer === 0 ? onClose : handleSubmit}
            className="w-full bg-mv-darkblue text-white p-2 rounded hover:bg-blue-700"
          >
            {reattempt > 3 || timer === 0 ? "Okay" : "Submit"}
          </button>
        </div>
        {timer === 0 && (
          <div className="text-center mt-4">
            <button
              disabled={timer > 0}
              onClick={() => handleResend()}
              className={
                "text-mv-darkblue" +
                (timer > 0
                  ? " cursor-not-allowed text-gray-300 "
                  : " hover:underline cursor-pointer")
              }
            >
              Resend Code
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TwoFactorAuthModal;
